<template>
  <div :class="containerClass">
    <div v-if="!loading && !error"
         class="layout-header"
         :style="`background-image: url(${image_url}); background-position: ${background_position}`">
    </div>

    <component :is="currentComponent"></component>
  </div>
</template>

<script>
import Donation from '@/components/Donation.vue';
import Product from '@/components/Product.vue';
import SingleProduct from '@/components/SingleProduct.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';
import NotFound from '@/components/NotFound.vue';
import Exhausted from '@/components/Exhausted.vue';
import Disabled from '@/components/Disabled.vue';
import axios from 'axios';

export default {
  name: 'home',
  components: {
    Donation,
    Product,
    SingleProduct,
    LoadingScreen,
    notfound: NotFound,
    Exhausted,
    Disabled,
  },
  computed: {
    campaign() {
      return this.$store.getters['application/getCampaign'];
    },
    error() {
      return this.$store.getters['application/getError'];
    },
    image_url() {
      if (this.campaign.image) {
        return `${axios.defaults.baseURL.replace(/\/$/gi, '')}/${this.campaign.image.replace(/^\//gi, '')}`;
      }
      return '';
    },
    background_position() {
      if (this.campaign.background_position) {
        return this.campaign.background_position;
      }
      return 'center center';
    },
    currentComponent() {
      if (this.loading) {
        return 'loading-screen';
      }
      if (this.error) {
        return this.error;
      }
      if (this.campaign.id) {
        switch (this.campaign.type) {
          case 'product_single':
            return 'single-product';
          case 'product_multiple':
            return 'product';
          case 'donation':
            return 'donation';
          default:
        }
      }

      return 'notfound';
    },
    loading() {
      return !this.error && !this.campaign.id;
    },
    containerClass() {
      if (this.error) {
        return 'exception';
      }
      return '';
    },
  },
  watch: {
    campaign() {
      if (this.campaign && this.campaign.title) {
        document.title = `${this.campaign.title} - QR Direct`;
      }
    },
  },
  created() {
    this.$store.dispatch('application/getCampaign', {
      campaign: this.$route.params.campaign_code,
      customer: this.$route.params.customer_code,
    });
  },
};
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';
  .exception {
    margin-bottom: -100px;
  }
</style>
